import { render } from "./header-btns.vue?vue&type=template&id=e9eb28e2"
import script from "./header-btns.vue?vue&type=script&setup=true&lang=js"
export * from "./header-btns.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/reports/pages/activity-log/components/header-btns.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e9eb28e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e9eb28e2', __exports__)) {
    console.log('reload')
    api.reload('e9eb28e2', __exports__)
  }
  
  module.hot.accept("./header-btns.vue?vue&type=template&id=e9eb28e2", () => {
    console.log('re-render')
    api.rerender('e9eb28e2', render)
  })

}


export default __exports__